module.exports = __webpack_public_path__ + "static/about-top-e221af42c868831252018b1f3cc1b42e.png";